import { Box, Typography, styled, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface ChatMessageProps {
  children: ReactNode | string; // Accepts any ReactNode as children
  type: 'question' | 'answer' | 'secondaryQuestion'; // Type of message
}

const MessageContainer = styled(Box)<{
  type: 'question' | 'answer' | 'secondaryQuestion';
}>(({ type }) => ({
  display: 'flex',
  justifyContent: type === 'answer' ? 'flex-start' : 'flex-end',
}));

const MessageBubble = styled(Typography)<{
  type: 'question' | 'answer' | 'secondaryQuestion';
  color: string;
  bgcolor: string;
  bubblecolor: string;
  lineheight?: string;
}>(({ type, bgcolor, color, bubblecolor, lineheight }) => ({
  'maxWidth': '100%',
  'wordWrap': 'break-word',
  'lineHeight': lineheight,
  'position': 'relative',
  'padding': '8px 20px',
  'borderRadius': '25px',
  'color': color,
  'background': bgcolor,
  '&:before, &:after': {
    content: '""',
    position: 'absolute',
    height: '20px',
    bottom: 0,
  },
  '&:before': {
    backgroundColor: bgcolor,
    width: type === 'answer' ? '20px' : '20px',
    borderBottomLeftRadius: type === 'question' ? '16px 14px' : '0',
    borderBottomRightRadius: type === 'question' ? '0' : '16px',
    right: type === 'question' ? '-7px' : 'unset',
    left: type === 'question' ? 'unset' : '-7px',
  },
  '&:after': {
    backgroundColor: bubblecolor,
    width: '10px',
    borderBottomLeftRadius: type === 'question' ? '10px' : '0',
    borderBottomRightRadius: type === 'question' ? '0' : '10px',
    right: type === 'question' ? '-10px' : 'unset',
    left: type === 'question' ? 'unset' : '-10px',
  },
}));

const ChatMessage = ({ children, type }: ChatMessageProps) => {
  const theme = useTheme();
  return (
    <MessageContainer type={type}>
      <MessageBubble
        variant='body1'
        bgcolor={
          type === 'question' || type === 'secondaryQuestion'
            ? theme.palette.custom.chatBotLLM.questionColor
            : 'white'
        }
        color={theme.palette.custom.textColor}
        type={type}
        bubblecolor={theme.palette.custom.chatBotLLM.llmbgColor}
        fontWeight={400}
        lineheight='1.1'
      >
        {children}
      </MessageBubble>
    </MessageContainer>
  );
};

export default ChatMessage;
